import { render, staticRenderFns } from "./ViewFeeReceipt.vue?vue&type=template&id=c27a256a&scoped=true&"
import script from "./ViewFeeReceipt.vue?vue&type=script&lang=js&"
export * from "./ViewFeeReceipt.vue?vue&type=script&lang=js&"
import style0 from "./ViewFeeReceipt.vue?vue&type=style&index=0&id=c27a256a&media=print&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27a256a",
  null
  
)

export default component.exports